module.exports = __webpack_public_path__ + "static/img/coe-4ton-red.a1688f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-4ton-red.svg
// module id = 2d8Q
// module chunks = 82